/*
*
* Home actions
*
*/

import {
  SET_NOTIFICATIONS,
  SET_NOTIFICATIONS_DATA
} from './constants';


export function setNotification(value, type) {

  return {
    type: SET_NOTIFICATIONS,
    value: {
      value: value,
      type: type
    }
  };
}


export function setNotificationData(payload) {
  return {
    type: SET_NOTIFICATIONS_DATA,
    payload,
  };
}
